import {AbstractAcStandardMapper} from "../abstract-ac-standard.mapper";

export class FrAcCafSynthesisMapper extends AbstractAcStandardMapper {
}
